var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(-1038 -489)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 28,
    height: 28,
    transform: "translate(1038 489)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-copy",
    "data-name": "Icon feather-copy",
    transform: "translate(1038 489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M15.647,13.5h9.664a2.147,2.147,0,0,1,2.147,2.147v9.664a2.147,2.147,0,0,1-2.147,2.147H15.647A2.147,2.147,0,0,1,13.5,25.311V15.647A2.147,2.147,0,0,1,15.647,13.5Z",
    transform: "translate(-2.984 -2.984)",
    fill: "none",
    stroke: "#d1d1d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M6.221,16.959H5.147A2.147,2.147,0,0,1,3,14.811V5.147A2.147,2.147,0,0,1,5.147,3h9.664a2.147,2.147,0,0,1,2.147,2.147V6.221",
    fill: "none",
    stroke: "#d1d1d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy1);
export default __webpack_public_path__ + "static/media/copy1.4c6920ad48117a5bb0817076fb9b1c55.svg";
export { ForwardRef as ReactComponent };